import { create } from 'zustand'

const useMegaMenu = create(set => ({
  
  // ^ TODO : NAVBAR COLOR TRIGGER FUNCTION

  isHovered: true,
  onEnter: () => set({ isHovered: true }),
  onExit: () => set({ isHovered: false }),
  id: null,
  resetId: () => set({ id: null }),
  expand: false,
  onExpand: section => set({ expand: true, id: section }),
  onCollapse: () => set({ expand: false, id: ' ' })
}))

export default useMegaMenu
